import { Assert } from '@team/assert';

export const normalize = (value: unknown) => {
  if (value instanceof Error) {
    return value;
  }

  if (Assert.isString(value)) {
    return new Error(value);
  }

  const serializedValue = JSON.stringify(value);

  return new Error(serializedValue, { cause: value });
};
